import { doRedirectDelete } from "../../actions/thunks/schemaThunks";

const onEditDelete = (component, endpoint = null, redirectUrl = null) => {
  const deleteEndpoint = endpoint || component.props.loadEndpoint;
  const url = redirectUrl || component.props.deleteRedirectUrl;
  component.props.dispatch(
    doRedirectDelete({
      accessToken: component.props.accessToken,
      endpoint: deleteEndpoint,
      successRedirectUrl: url,
      navigate: component.props.navigate,
    })
  );
};

export default onEditDelete;
